// TODO delete when KPIS are implemented

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['validationErrors'];

  clear(event) {
    event.target.reset();
  }

  clearValidationErrors() {
    if (this.hasValidationErrorsTarget) {
      this.validationErrorsTargets.forEach((element) => {
        try {
          element.innerText = '';
        } catch (e) {}
      });
    }
  }

  removeWhitespace(event) {
    const input = event.target;
    input.value = input.value.replace(/\s+/g, "");
  }

  toggleHiddenInputs(event) {
    const triggerElement = event.target;
    const targetSelector = triggerElement.dataset.toggleTarget;
    const targetElement = document.querySelector(targetSelector);
    
    if (!targetElement) return;
    
    const fields = targetElement.querySelectorAll('input, select, textarea');
    const isActive = triggerElement.value && triggerElement.value !== '';
    
    targetElement.style.display = isActive ? '' : 'none';
    fields.forEach((field) => (field.disabled = !isActive));
  }
}
